import React from 'react';
import { useIntl } from 'react-intl';

import { FlagIcon } from 'components';
import { ALL, OverlayType } from '../../constants';
import { canFilterByTimePeriods, getNameByCountryCode } from '../../utils';
import messages from '../Categorizer/messages.js'; // TODO: probably need to move this in root translations
import FilterByTimePeriod from '../FilterByTimePeriod';
import SportsNavigation from '../SportsNavigation';
import BackLink from './BackLink';
import FeaturedTournamentsHeading from './FeaturedTournamentsHeading';
import FilterBySportHeading from './FilterBySportHeading';
import Overlay from './Overlay';
import SportsList from './SportsList';
import useMobileFilters from './useMobileFilters';

import './mobileFilters.scss';

const MobileFilters: React.FC = () => {
    const { formatMessage } = useIntl();
    const {
        selectedCountryKey,
        isSelectedCountryCodeWithAll,
        handleClickBack,
        countryCode,
        tournamentName,
        tournamentId,
        currentOverlay,
        withSportNavigation,
    } = useMobileFilters();

    const BackLinkTitle = isSelectedCountryCodeWithAll ? (
        <div styleName="title">
            <FlagIcon countryCode={selectedCountryKey} />
            {getNameByCountryCode(formatMessage, selectedCountryKey)}
        </div>
    ) : (
        <div styleName="title">
            {countryCode && <FlagIcon countryCode={countryCode} />}
            {selectedCountryKey === ALL
                ? formatMessage(messages.selectAll)
                : tournamentName}
        </div>
    );

    return (
        <div styleName="container">
            {canFilterByTimePeriods() && <FilterByTimePeriod />}

            <div styleName="filters">
                <FilterBySportHeading />
                <FeaturedTournamentsHeading />
                <SportsList />
            </div>

            {withSportNavigation && <SportsNavigation />}

            {currentOverlay === OverlayType.NONE && tournamentId && (
                <BackLink title={BackLinkTitle} onClick={handleClickBack} />
            )}
            <Overlay />
        </div>
    );
};

export default React.memo(MobileFilters);
